import React from 'react';
import I18n from 'i18n-js';
import { RCGrid } from '@reverbdotcom/cadence/components';
import { OverflowingRow } from '@reverbdotcom/commons';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import { MParticleEventName } from '@reverbdotcom/commons/src/elog/mparticle_tracker';
import gemNudgeIcon from '@reverbdotcom/cadence/images/nudge/gem.svg';
import exploreNudgeIcon from '@reverbdotcom/cadence/images/nudge/explore-nudge.svg';
import trustBadgeNudgeIcon from '@reverbdotcom/cadence/images/nudge/trust-shield.svg';

const valueProps = [
  {
    key: 'greatDeals',
    title: I18n.t('discovery.homepage.valueProps.greatDeals.title'),
    subtitle: I18n.t('discovery.homepage.valueProps.greatDeals.subtitle'),
    icon: gemNudgeIcon,
    ctaText: I18n.t('discovery.homepage.valueProps.greatDeals.ctaText'),
    ctaLink: '/promo/deals-and-steals',
  },
  {
    key: 'sellers',
    title: I18n.t('discovery.homepage.valueProps.sellers.title'),
    subtitle: I18n.t('discovery.homepage.valueProps.sellers.subtitle'),
    icon: exploreNudgeIcon,
    ctaText: I18n.t('discovery.homepage.valueProps.sellers.ctaText'),
    ctaLink: '/promo/top-sellers-recent-releases',
  },
  {
    key: 'buyerProtection',
    title: I18n.t('discovery.homepage.valueProps.buyerProtection.title'),
    subtitle: I18n.t('discovery.homepage.valueProps.buyerProtection.subtitle'),
    icon: trustBadgeNudgeIcon,
    ctaText: I18n.t('discovery.homepage.valueProps.buyerProtection.ctaText'),
    ctaLink: '/page/reverb-protection',
  },
];

function renderValueProp(valueProp, position) {
  return (
    <div className="padding-5 mobile-padding-0 mobile-d-flex mobile-fx-align-center">
      <div className="align-center mobile-mr-5">
        <img src={valueProp.icon} alt=""/>
      </div>
      <div className="align-center">
        <h2 className="weight-bold size-150 mtb-3 mobile-align-left">{valueProp.title}</h2>
        <div className="mtb-3 mobile-d-none">{valueProp.subtitle}</div>
        <div className="weight-bold mtb-3 mobile-align-left ">
          <CoreLink
            to={valueProp.ctaLink}
            clickEvent={{
              componentName: 'LoggedOutValueProps',
              eventName: MParticleEventName.ClickedValueProp,
              position: position,
            }}
          >
            <span className="color-black td-underline">{valueProp.ctaText}</span>
          </CoreLink>
        </div>

      </div>
    </div>
  );
}

export default function ValueProps() {
  return (
    <OverflowingRow>
      <RCGrid>
        {
          valueProps.map((valueProp, index) => {
            return (
              <RCGrid.Item
                colSpan={{ desktop: 4, tablet: 4, mobile: 12 }}
                key={valueProp.key}
              >
                {renderValueProp(valueProp, index)}
              </RCGrid.Item>
            );
          })
        }
      </RCGrid>
    </OverflowingRow>
  );
}
